import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { WizardQuoteInstaller } from '../interfaces/wizardquote-installer.interface'
import { map, Observable } from 'rxjs'
import { environment } from 'projects/quoting-app/src/environments/environment'
import { ApiResponse } from 'projects/sf-quoting-lib/src/lib/interfaces/api-response.interface'

@Injectable({
    providedIn: 'root',
})
export class WizardquoteService {
    #httpClient = inject(HttpClient)

    getInstallerWizardquote(id: string): Observable<WizardQuoteInstaller> {
        return this.#httpClient
            .get<ApiResponse<WizardQuoteInstaller>>(`${environment.baseUrl}public/wizardquote/installer/${id}`)
            .pipe(
                map(response => {
                    return response.result
                })
            )
    }
}
